import { getBranding } from '@/lib/branding'
import { urlThuongHieu } from '@/lib/config'
import { useAuthStore } from '@/stores/auth-store'
import { cn } from '@/lib/utils'

/**
 * Logo ở thanh menu: tổ chức có logo riêng (super admin hoặc owner đặt ở
 * Cài đặt → Thông tin công ty) thì dùng, không thì logo nền tảng.
 */
export function BrandLogo({ className, showText = true }: { className?: string; showText?: boolean }) {
  const b = getBranding()
  const org = useAuthStore((s) => s.user?.org)
  const src = org?.logoUrl ? urlThuongHieu(org.logoUrl) : b.logoUrl
  const alt = org?.logoUrl ? org.name : b.brandName
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <img
        src={src}
        alt={alt}
        className="h-8 w-auto max-w-[140px] object-contain"
        onError={(e) => {
          ;(e.currentTarget as HTMLImageElement).style.display = 'none'
        }}
      />
      {showText && !src && <span className="text-lg font-bold">{alt}</span>}
    </div>
  )
}
